import { createFileRoute } from '@tanstack/react-router';
import { ToolCatalogPage } from '@/pages/member-portal/tools/ToolCatalogPage';

// Member-facing tool catalog (grouped by area).
function MemberPortalToolsRoute() {
	return <ToolCatalogPage />;
}

export const Route = createFileRoute('/_authenticated/_app/member-portal/tools')({
	component: MemberPortalToolsRoute,
});
